module.exports = __webpack_public_path__ + "media/img/pages/companies/sonceboz-54432d1e9cc1da097eba53c4b2e0e1b8.png";